import { connect } from "react-redux";
import EmpCreateTicket from "./empCreateTicket";
import { bindActionCreators } from "redux";
import { createTicket } from "services/redux/employeeTickets/createTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { fetchSitesLocationMap } from "services/redux/sitesLocationMap/action"

const mapStateToProps = (state) => ({
    documentUrlData: state.fileUploadReducer.documentUrlData,
    createTicketRes : state.createTicketReducer.createTicketRes,
    sitesLocMapList: state.sitesLocMapReducer.sitesLocMapList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createTicket,
        documentUploadUrl,
        fetchSitesLocationMap,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmpCreateTicket);
